import { useSelector } from 'react-redux';
import { currentTokenSelector, currentUserSelector } from 'store/auth/auth.selectors';

export const useAuth = () => {
  const auth = useSelector(currentTokenSelector);
  const user = useSelector(currentUserSelector);
  return { user, auth };
};
